'use strict';
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dBase$002dObservable from "./com.raquo.airstream.core.-Base-Observable.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
function $f_Lcom_raquo_airstream_common_SingleParentStream__onStart__V($thiz) {
  $j_com$002eraquo$002eairstream$002ecore$002e$002dBase$002dObservable.$f_Lcom_raquo_airstream_core_WritableObservable__addInternalObserver__Lcom_raquo_airstream_core_InternalObserver__Z__V($thiz.eB(), $thiz, false);
}
export { $f_Lcom_raquo_airstream_common_SingleParentStream__onStart__V as $f_Lcom_raquo_airstream_common_SingleParentStream__onStart__V };
function $f_Lcom_raquo_airstream_common_SingleParentStream__onStop__V($thiz) {
  $j_com$002eraquo$002eairstream$002ecore$002e$002dBase$002dObservable.$f_Lcom_raquo_airstream_core_BaseObservable__removeInternalObserver__Lcom_raquo_airstream_core_InternalObserver__V($thiz.eB(), $thiz);
}
export { $f_Lcom_raquo_airstream_common_SingleParentStream__onStop__V as $f_Lcom_raquo_airstream_common_SingleParentStream__onStop__V };
